import { SystemLayoutStyled } from './styled';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTE_PATH } from 'utils/constants/routePath';
import { NavbarWidget, SidebarWidget } from 'widgets';

const SystemLayout = () => {
  // ทุกหน้าใน /system เป็น children ของ layout นี้ จึงเป็นจุดเดียวที่คุมได้ทั้งหมด
  // ก่อนหน้านี้ไม่มีการตรวจเลย ใครพิมพ์ URL เข้ามาก็เห็นข้อมูลลูกค้าได้
  // (ชื่อ เบอร์โทร ที่อยู่) โดยไม่ต้อง login
  //
  // ตรวจแค่ว่ามี token ไหม ความถูกต้องจริงบังคับที่ฝั่ง api ทุก request อยู่แล้ว
  const token = localStorage.getItem('token');
  if (!token) {
    // replace = ไม่ให้กดย้อนกลับมาหน้าที่เข้าไม่ได้
    return <Navigate to={ROUTE_PATH.LOGIN} replace />;
  }

  return (
    <SystemLayoutStyled>
      <div className="left_mainlayout">
        <SidebarWidget />
      </div>
      <div className="right_mainlayout">
        <NavbarWidget />
        <div className="body_mainlayout">
          <Outlet />
        </div>
      </div>
    </SystemLayoutStyled>
  );
};

export default SystemLayout;
